import { adminTypes } from "@admin/admin-types.di";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { UserCreateToSpatialLevel, UserResume } from "@iot-platform/user";
import { inject, injectable } from "inversify";

@injectable()
export class UserCreateToSpatialLevelUseCase {
    constructor(
        @inject(adminTypes.repositories.AdminRepository)
        private readonly adminRepository: AdminRepository,
    ) {}

    async execute(
        user: UserCreateToSpatialLevel,
    ): Promise<Nullable<UserResume>> {
        const createResult =
            await this.adminRepository.createUserToSpatialLevel(user);

        return createResult.match(
            (userCreated) => userCreated,
            (error) => {
                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
